import CSVFileValidator from 'csv-file-validator'
import SharedModal from '../../../sharedComponent/SharedModal'
import CustomButton from '../../../sharedComponent/CustomButton'
import DragDrop from '../../../sharedComponent/UploadDrag'
import { useEffect, useState } from 'react'
import {
  CREATE_BULK_PRODUCTS,
  GETPRODUCTSETUP,
  GET_ALL_SCRIPTS_LIST,
} from '../../../../utils/GraphQLAPI'
import { useLazyQuery, useMutation } from '@apollo/client'
import succesIcon from '../../../../_metronic/images/successIcon.svg'
import { ENUMS } from '../../../../utils/GlobalEnum'
import { GLOBAL_CONSTANTS } from '../../../../utils/GlobalConstants'
import { billingMethodOptions } from './ProductModal/AddProductUtils'

import moment from 'moment'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { DownloadTemplate } from '../../../sharedComponent/DownloadTemplate/DownloadTemplate'
import { alert } from '../../../../utils/helper'
import { ParsedValueType } from './UploadProductsUtils'
const MySwal = withReactContent(Swal)
type UploadProductsType = {
  showModal: boolean
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  refetchProduct: () => void
  isProductListDynamic: boolean
}
const validate = (value: any, row: any, checkType: string, toCheckArray?: any) => {
  const isElectricOrDual =
    row.includes(ENUMS.product.commodity.Electric) || row.includes(ENUMS.product.commodity.Dual)
  const isGasOrDual =
    row.includes(ENUMS.product.commodity.Gas) || row.includes(ENUMS.product.commodity.Dual)
  const isDynamic = row.includes('Dynamic')
  const isStandard = row.includes('Standard')
  const isValueValidNumber = !isNaN(Number(value)) && Number(value) >= 0

  const checkRequiredDynamic = (commodityCheck: boolean) => {
    if (toCheckArray === 'rate' || toCheckArray === 'term') {
      return value === ''
    } else if (commodityCheck) {
      return Boolean(value)
    } else {
      return true
    }
  }

  const checkRequiredStandard = (commodityCheck: boolean) => {
    if (toCheckArray === 'rate') {
      return isValueValidNumber
    } else if (toCheckArray === 'term') {
      return true
    } else {
      return value === ''
    }
  }

  switch (checkType) {
    case 'ELECTRICREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP':
      if (isElectricOrDual && Boolean(value)) {
        return toCheckArray.includes(value)
      } else if (row.includes(ENUMS.product.commodity.Gas)) {
        return true
      } else {
        return false
      }

    case 'ELECTRICREQUIRED':
      if ((isElectricOrDual && Boolean(value)) || row.includes(ENUMS.product.commodity.Gas)) {
        return true
      } else {
        return false
      }

    case 'ELECTRICOPTIONAL':
      if (isElectricOrDual || row.includes(ENUMS.product.commodity.Gas)) {
        return true
      } else {
        return false
      }

    case 'GASOPTIONAL':
      if (isGasOrDual || row.includes(ENUMS.product.commodity.Electric)) {
        return true
      } else {
        return false
      }

    case 'GASREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP':
      if (isGasOrDual && Boolean(value)) {
        return toCheckArray.includes(value)
      } else if (row.includes(ENUMS.product.commodity.Electric)) {
        return true
      } else {
        return false
      }

    case 'GASREQUIRED':
      if ((isGasOrDual && Boolean(value)) || row.includes(ENUMS.product.commodity.Electric)) {
        return true
      } else {
        return false
      }

    case 'RequiredFieldDynamicElectric':
      if (isDynamic) {
        return checkRequiredDynamic(isElectricOrDual)
      } else if (isStandard) {
        return checkRequiredStandard(isElectricOrDual)
      }
      break

    case 'RequiredFieldDynamicGas':
      if (isDynamic) {
        return checkRequiredDynamic(isGasOrDual)
      } else if (isStandard) {
        return checkRequiredStandard(isGasOrDual)
      }
      break

    default:
      return false
  }
}

const UploadProducts = ({
  showModal,
  setShowModal,
  refetchProduct,
  isProductListDynamic,
}: UploadProductsType) => {
  // Get product details query
  const [getProductSetup, { data: productDetails }] = useLazyQuery(GETPRODUCTSETUP, {
    onCompleted: (resData) => { },
    fetchPolicy: 'network-only',
  })
  //to get all the scripts
  const [getAllScripts, { data: scripts }] = useLazyQuery(GET_ALL_SCRIPTS_LIST, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    variables: {
      getScriptsInput: {
        isActive: true,
      },
    },
  })
  const [createBulkProduct] = useMutation(CREATE_BULK_PRODUCTS, {
    onCompleted: (data) => {
      refetchProduct()
      alert('Products uploaded successfully', 'success')
    },
    onError: (err) => alert(err.message, 'error'),
    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
  })

  useEffect(() => {
    getProductSetup()
    getAllScripts()
  }, [])
  const handleModalClose = () => {
    setShowModal(false)
    setFile(null)
    setErrorMsg('')
  }

  const [file, setFile] = useState<File | null>(null)
  const [errorMsg, setErrorMsg] = useState('')
  const [parsedValues, setParsedValues] = useState<any>([])
  useEffect(() => {
    if (file) {
      //to get all the product setup values ----start
      const commodityValues = productDetails.getProductDetail
        .filter((data: any) => data.enum === ENUMS.productSetup.commodity)[0]
        .names.map((name: any) => name.value)
      const customerTypeValues = productDetails.getProductDetail
        .filter((data: any) => data.enum === ENUMS.productSetup.customerType)[0]
        .names.map((name: any) => name.value)
      const unitValues = productDetails.getProductDetail
        .filter((data: any) => data.enum === ENUMS.productSetup.unit)[0]
        .names.map((name: any) => name.value)
      const brandValues = productDetails.getProductDetail
        .filter((data: any) => data.enum === ENUMS.productSetup.brand)[0]
        .names.map((name: any) => name.value)
      const contractTypeValues = productDetails.getProductDetail
        .filter((data: any) => data.enum === ENUMS.productSetup.contractType)[0]
        .names.map((name: any) => name.value)
      const utilitiesValues = productDetails.getProductDetail
        .filter((data: any) => data.enum === ENUMS.productSetup.utility)[0]
        .names.map((name: any) => name.value)
      const productTypeValue = ['Standard', 'Dynamic']
      //to get all the product setup values ----end
      const scriptNames = scripts.getAllScripts.scripts.map((script: any) => script.scriptName)
      //sheet header and validation config
      const config: any = {
        headers: !isProductListDynamic
          ? [
            {
              name: 'Product Name',
              inputName: 'name',
              required: true,
              requiredError(headerName: string, rowNumber: number, columnNumber: number) {
                return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
              }
            },
            {
              name: 'Status',
              inputName: 'isActive',
              required: true,
              requiredError(headerName: string, rowNumber: number, columnNumber: number) {
                return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
              },
              validate: (isActive: string) => {
                if (
                  isActive.toLocaleLowerCase() === 'active' ||
                  isActive.toLocaleLowerCase() === 'inactive'
                ) {
                  return true
                } else {
                  return false
                }
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            },
            {
              name: 'Commodity',
              inputName: 'commodityId',
              required: true,
              requiredError(headerName: string, rowNumber: number, columnNumber: number) {
                return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
              },
              validate: (commodity: string) => {
                return commodityValues.includes(commodity)
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            },
            {
              name: 'Brand',
              inputName: 'brandTypeId',
              required: false,
              validate: (brand: string) => {
                if (Boolean(brand)) {
                  return brandValues.includes(brand)
                } else {
                  return true
                }
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            },
            {
              name: 'Customer Type',
              inputName: 'customerTypeId',
              required: true,
              validate: (brand: string) => {
                if (Boolean(brand)) {
                  return customerTypeValues.includes(brand)
                } else {
                  return false
                }
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            },
            {
              name: 'Script Name',
              inputName: 'scriptId',
              required: false,
              validate: (scriptName: string) => {
                if (Boolean(scriptName)) {
                  return scriptNames.includes(scriptName)
                } else {
                  return true
                }
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            },
            {
              name: 'E_Utility',
              inputName: 'utilityId',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => {
                return validate(
                  value,
                  row,
                  'ELECTRICREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP',
                  utilitiesValues
                )
              },
            },
            {
              name: 'E_Contract Type',
              inputName: 'contractTypeId',
              required: false,

              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => {
                return validate(
                  value,
                  row,
                  'ELECTRICREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP',
                  contractTypeValues
                )
              },
            },
            {
              name: 'E_Unit',
              inputName: 'unitTypeId',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(
                  value,
                  row,
                  'ELECTRICREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP',
                  unitValues
                ),
            },
            {
              name: 'E_Rate',
              inputName: 'rate',
              required: false,
              validate: (grate: string) => {
                if (isNaN(Number(grate)) || Number(grate) < 0) {
                  return false
                }
                return true
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            },
            {
              name: 'E_Second Rate',
              inputName: 'secondRate',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'ELECTRICOPTIONAL'),
            },
            {
              name: 'E_Term',
              inputName: 'term',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'ELECTRICOPTIONAL'),
            },

            {
              name: 'E_Early Termination Fee',
              inputName: 'earlyTerminationFee',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'ELECTRICOPTIONAL'),
            },
            {
              name: 'E_Service Fee',
              inputName: 'serviceFee',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'ELECTRICOPTIONAL'),
            },
            {
              name: 'E_Adder',
              inputName: 'adder',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'ELECTRICOPTIONAL'),
            },
            {
              name: 'E_Deposit',
              inputName: 'deposit',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'ELECTRICOPTIONAL'),
            },
            {
              name: 'E_Product Code',
              inputName: 'ecode',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'ELECTRICREQUIRED'),
            },
            {
              name: 'E_Billing Method',
              inputName: 'ebillingMethod',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(
                  value,
                  row,
                  'ELECTRICREQUIRED',
                  billingMethodOptions.map((data) => data.value)
                ),
            },

            {
              name: 'G_Utility',
              inputName: 'gutilityId',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => {
                return validate(
                  value,
                  row,
                  'GASREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP',
                  utilitiesValues
                )
              },
            },
            {
              name: 'G_Contract Type',
              inputName: 'gcontractTypeId',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => {
                return validate(
                  value,
                  row,
                  'GASREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP',
                  contractTypeValues
                )
              },
            },
            {
              name: 'G_Unit',
              inputName: 'gunitTypeId',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'GASREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP', unitValues),
            },
            {
              name: 'G_Rate',
              inputName: 'grate',
              required: false,
              validate: (grate: string) => {
                if (isNaN(Number(grate)) || Number(grate) < 0) {
                  return false
                }
                return true
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            },
            {
              name: 'G_Second Rate',
              inputName: 'gsecondRate',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
            },
            {
              name: 'G_Term',
              inputName: 'gterm',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
            },
            {
              name: 'G_Early Termination Fee',
              inputName: 'gearlyTerminationFee',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
            },

            {
              name: 'G_Service Fee',
              inputName: 'gserviceFee',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
            },
            {
              name: 'G_Adder',
              inputName: 'gadder',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
            },
            {
              name: 'G_Deposit',
              inputName: 'gdeposit',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
            },
            {
              name: 'G_Product Code',
              inputName: 'gcode',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => validate(value, row, 'GASREQUIRED'),
            },
            {
              name: 'G_Billing Method',
              inputName: 'gbillingMethod',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(
                  value,
                  row,
                  'GASREQUIRED',
                  billingMethodOptions.map((data) => data.value)
                ),
            },
            {
              name: 'Start Date',
              inputName: 'startDate',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              validate: (startDate: Date) => {
                return true
              },
            },
            {
              name: 'End Date',
              inputName: 'endDate',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              validate: (endDate: Date) => {
                return true
              },
            },
            {
              name: 'Additional Information',
              inputName: 'notes',
              required: false,
              optional: true,
            },
          ]
          : [
            {
              name: 'Product Name',
              inputName: 'name',
              required: true,
              requiredError(headerName: string, rowNumber: number, columnNumber: number) {
                return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
              },
            },
            {
              name: 'Status',
              inputName: 'isActive',
              required: true,
              requiredError(headerName: string, rowNumber: number, columnNumber: number) {
                return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
              },
              validate: (isActive: string) => {
                if (
                  isActive.toLocaleLowerCase() === 'active' ||
                  isActive.toLocaleLowerCase() === 'inactive'
                ) {
                  return true
                } else {
                  return false
                }
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            },
            {
              name: 'Commodity',
              inputName: 'commodityId',
              required: true,
              requiredError(headerName: string, rowNumber: number, columnNumber: number) {
                return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
              },
              validate: (commodity: string) => {
                return commodityValues.includes(commodity)
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            },
            {
              name: 'Product Type',
              inputName: 'ProductTypeId',
              required: false,
              validate: (value: string) => {
                return productTypeValue.includes(value)
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            },
            {
              name: 'Brand',
              inputName: 'brandTypeId',
              required: false,
              validate: (brand: string) => {
                if (Boolean(brand)) {
                  return brandValues.includes(brand)
                } else {
                  return true
                }
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            },
            {
              name: 'Customer Type',
              inputName: 'customerTypeId',
              required: true,
              validate: (brand: string) => {
                if (Boolean(brand)) {
                  return customerTypeValues.includes(brand)
                } else {
                  return false
                }
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            },
            {
              name: 'Script Name',
              inputName: 'scriptId',
              required: false,
              validate: (scriptName: string) => {
                if (Boolean(scriptName)) {
                  return scriptNames.includes(scriptName)
                } else {
                  return true
                }
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            },
            {
              name: 'E_Utility',
              inputName: 'utilityId',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => {
                return validate(
                  value,
                  row,
                  'ELECTRICREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP',
                  utilitiesValues
                )
              },
            },
            {
              name: 'E_Contract Type',
              inputName: 'contractTypeId',
              required: false,

              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => {
                return validate(
                  value,
                  row,
                  'ELECTRICREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP',
                  contractTypeValues
                )
              },
            },
            {
              name: 'E_Unit',
              inputName: 'unitTypeId',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(
                  value,
                  row,
                  'ELECTRICREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP',
                  unitValues
                ),
            },
            {
              name: 'E_Rate',
              inputName: 'rate',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'RequiredFieldDynamicElectric', 'rate'),
            },
            {
              name: 'E_Rate Minimum',
              inputName: 'rateMinimum',
              required: false,
              validate: (grate: string) => {
                if (isNaN(Number(grate)) || Number(grate) < 0) {
                  return false
                }
                return true
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'RequiredFieldDynamicElectric'),
            },
            {
              name: 'E_Rate Maximum',
              inputName: 'rateMaximum',
              required: false,
              validate: (grate: string) => {
                if (isNaN(Number(grate)) || Number(grate) < 0) {
                  return false
                }
                return true
              },
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'RequiredFieldDynamicElectric'),
            },
            {
              name: 'E_Second Rate',
              inputName: 'secondRate',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'ELECTRICOPTIONAL'),
            },
            {
              name: 'E_Term',
              inputName: 'term',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'RequiredFieldDynamicElectric', 'term'),
            },
            {
              name: 'E_Term Minimum',
              inputName: 'termMinimum',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'RequiredFieldDynamicElectric'),
            },
            {
              name: 'E_Term Maximum',
              inputName: 'termMaximum',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'RequiredFieldDynamicElectric'),
            },
            {
              name: 'E_Early Termination Fee',
              inputName: 'earlyTerminationFee',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'ELECTRICOPTIONAL'),
            },
            {
              name: 'E_Service Fee',
              inputName: 'serviceFee',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'ELECTRICOPTIONAL'),
            },
            {
              name: 'E_Adder',
              inputName: 'adder',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'ELECTRICOPTIONAL'),
            },
            {
              name: 'E_Deposit',
              inputName: 'deposit',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'ELECTRICOPTIONAL'),
            },
            {
              name: 'E_Product Code',
              inputName: 'ecode',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'ELECTRICREQUIRED'),
            },
            {
              name: 'E_Billing Method',
              inputName: 'ebillingMethod',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(
                  value,
                  row,
                  'ELECTRICREQUIRED',
                  billingMethodOptions.map((data) => data.value)
                ),
            },

            {
              name: 'G_Utility',
              inputName: 'gutilityId',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => {
                return validate(
                  value,
                  row,
                  'GASREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP',
                  utilitiesValues
                )
              },
            },
            {
              name: 'G_Contract Type',
              inputName: 'gcontractTypeId',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => {
                return validate(
                  value,
                  row,
                  'GASREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP',
                  contractTypeValues
                )
              },
            },
            {
              name: 'G_Unit',
              inputName: 'gunitTypeId',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'GASREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP', unitValues),
            },
            {
              name: 'G_Rate',
              inputName: 'grate',
              required: false,

              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'RequiredFieldDynamicGas', 'rate'),
            },
            {
              name: 'G_Rate Minimum',
              inputName: 'grateMinimum',
              required: false,

              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'RequiredFieldDynamicGas'),
            },
            {
              name: 'G_Rate Maximum',
              inputName: 'grateMaximum',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'RequiredFieldDynamicGas'),
            },
            {
              name: 'G_Second Rate',
              inputName: 'gsecondRate',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
            },
            {
              name: 'G_Term',
              inputName: 'gterm',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'RequiredFieldDynamicGas', 'term'),
            },
            {
              name: 'G_Term Minimum',
              inputName: 'gtermMinimum',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'RequiredFieldDynamicGas'),
            },
            {
              name: 'G_Term Maximum',
              inputName: 'gtermMaximum',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(value, row, 'RequiredFieldDynamicGas'),
            },
            {
              name: 'G_Early Termination Fee',
              inputName: 'gearlyTerminationFee',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
            },

            {
              name: 'G_Service Fee',
              inputName: 'gserviceFee',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
            },
            {
              name: 'G_Adder',
              inputName: 'gadder',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
            },
            {
              name: 'G_Deposit',
              inputName: 'gdeposit',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
            },
            {
              name: 'G_Product Code',
              inputName: 'gcode',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) => validate(value, row, 'GASREQUIRED'),
            },
            {
              name: 'G_Billing Method',
              inputName: 'gbillingMethod',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              dependentValidate: (value: string, row: any) =>
                validate(
                  value,
                  row,
                  'GASREQUIRED',
                  billingMethodOptions.map((data) => data.value)
                ),
            },
            {
              name: 'Start Date',
              inputName: 'startDate',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              validate: (startDate: Date) => {
                return true
              },
            },
            {
              name: 'End Date',
              inputName: 'endDate',
              required: false,
              validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
                `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
              validate: (endDate: Date) => {
                return true
              },
            },
            {
              name: 'Additional Information',
              inputName: 'notes',
              required: false,
              optional: true,
            },
          ],
      }
      CSVFileValidator(file, config)
        .then((csvData) => {
          console.log(csvData.data, csvData.inValidData) // Array of objects from file
          // Array of error messages
          if (csvData.inValidData.length) {
            setErrorMsg(csvData.inValidData[0].message)
            setFile(null)
          } else {
            const modifiedData = () => {
              return csvData.data.map((product: any) => {
                const {
                  ProductTypeId,
                  gtermMinimum,
                  gtermMaximum,
                  grateMinimum,
                  grateMaximum,
                  rateMinimum,
                  rateMaximum,
                  termMinimum,
                  termMaximum,
                  ...rest
                } = product
                return {
                  ...rest,
                  isDynamicProduct: ProductTypeId ? ProductTypeId?.toLowerCase() === 'dynamic' : false,
                  dynamicProductInput: {
                    gtermMinimum: Boolean(product?.gtermMinimum) ? product?.gtermMinimum : null,
                    gtermMaximum: Boolean(product?.gtermMaximum) ? product?.gtermMaximum : null,
                    grateMinimum: Boolean(product?.grateMinimum)
                      ? Number(product?.grateMinimum)
                      : null,
                    grateMaximum: Boolean(product?.grateMaximum)
                      ? Number(product?.grateMaximum)
                      : null,
                    rateMinimum: Boolean(product?.rateMinimum)
                      ? Number(product?.rateMinimum)
                      : null,
                    rateMaximum: Boolean(product?.rateMaximum)
                      ? Number(product?.rateMaximum)
                      : null,
                    termMinimum: Boolean(product?.termMinimum) ? product?.termMinimum : null,
                    termMaximum: Boolean(product?.termMaximum) ? product?.termMaximum : null,
                  },
                }
              })
            }
            setParsedValues(modifiedData)
            setErrorMsg('')
          }
        })
        .catch((err) => { })
    }
  }, [file])

  interface ValidationResult {
    isValid: boolean
    errors: Array<{
      index: number
      field: 'startDate' | 'endDate'
      message: string
    }>
  }

  const handleDateValidation = async (
    parsedValues: ParsedValueType[]
  ): Promise<ValidationResult> => {
    const today = moment.utc()
    const errors: ValidationResult['errors'] = []
    let isValid = true

    parsedValues.forEach((value, index) => {
      const startDate = value.startDate ? moment.utc(value.startDate) : null
      const endDate = value.endDate ? moment.utc(value.endDate) : null

      // Validate start date
      if (startDate && startDate.isBefore(today, 'day')) {
        errors.push({
          index,
          field: 'startDate',
          message: "Start date cannot be in the past. It will be adjusted to today's date.",
        })
        value.startDate = today.toISOString()
      }

      // Validate end date
      if (endDate) {
        if (endDate.isBefore(today, 'day')) {
          errors.push({
            index,
            field: 'endDate',
            message: 'End date cannot be in the past',
          })
          isValid = false
        } else if (startDate && endDate.isBefore(startDate)) {
          errors.push({
            index,
            field: 'endDate',
            message: 'End date must be after start date',
          })
          isValid = false
        }
      }
    })

    // Show validation messages if there are any errors
    if (errors.length > 0) {
      const startDateErrors = errors.filter((e) => e.field === 'startDate')
      const endDateErrors = errors.filter((e) => e.field === 'endDate')
      if (startDateErrors.length > 0) {
        const result = await MySwal.fire({
          icon: 'warning',
          title: 'Date Adjustment Notice',
          text: `Some product start dates were in the past and have been adjusted to today's date. Would you like to proceed with the updated dates?`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: 'OK',
          showCancelButton: true,
          cancelButtonText: 'Cancel',
        })
        if (result.isDismissed) {
          handleModalClose()
          isValid = false
        }
      }

      if (endDateErrors.length > 0) {
        await MySwal.fire({
          icon: 'error',
          title: 'Date Validation',
          text: `${endDateErrors.length} record(s) have invalid end date(s). End date should be of future date and should come only after start date`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: 'OK',
        })
      }
    }

    return {
      isValid,
      errors,
    }
  }

  const handleSubmit = async () => {
    try {
      // Wait for validation to complete including user interactions
      const validation = await handleDateValidation(parsedValues)
      if (!validation.isValid) {
        return
      }

      // Get the ID's of the uploaded values
      const commodityValues = productDetails.getProductDetail.filter(
        (data: any) => data.enum === ENUMS.productSetup.commodity
      )[0].names
      const customerTypeValues = productDetails.getProductDetail.filter(
        (data: any) => data.enum === ENUMS.productSetup.customerType
      )[0].names
      const unitValues = productDetails.getProductDetail.filter(
        (data: any) => data.enum === ENUMS.productSetup.unit
      )[0].names
      const brandValues = productDetails.getProductDetail.filter(
        (data: any) => data.enum === ENUMS.productSetup.brand
      )[0].names
      const contractTypeValues = productDetails.getProductDetail.filter(
        (data: any) => data.enum === ENUMS.productSetup.contractType
      )[0].names
      const utilitiesValues = productDetails.getProductDetail.filter(
        (data: any) => data.enum === ENUMS.productSetup.utility
      )[0].names

      const payload = parsedValues.map((parsedValue: ParsedValueType) => ({
        ...parsedValue,
        productType: parsedValue.commodityId.toUpperCase(),
        isActive: parsedValue.isActive.toLowerCase() === 'active' ? true : false,
        commodityId: Boolean(parsedValue.commodityId)
          ? commodityValues.filter((data: any) => data.value === parsedValue.commodityId)[0].id
          : null,
        brandTypeId: Boolean(parsedValue?.brandTypeId)
          ? brandValues.filter((data: any) => data.value === parsedValue.brandTypeId)[0].id
          : null,
        customerTypeId: customerTypeValues.filter(
          (data: any) => data.value === parsedValue.customerTypeId
        )[0].id,
        scriptId: Boolean(parsedValue?.scriptId)
          ? scripts.getAllScripts.scripts.filter(
            (script: any) => script.scriptName === parsedValue?.scriptId
          )[0].scriptId
          : null,
        startDate: Boolean(parsedValue?.startDate)
          ? moment.utc(parsedValue.startDate).isBefore(moment.utc(), 'day')
            ? moment.utc().toISOString()
            : moment
              .utc(parsedValue.startDate)
              .set({
                hour: moment.utc().hour(),
                minute: moment.utc().minute(),
                second: moment.utc().second(),
                millisecond: moment.utc().millisecond(),
              })
              .toISOString()
          : null,
        endDate: Boolean(parsedValue?.endDate)
          ? moment.utc(parsedValue.endDate).isBefore(moment.utc(parsedValue.startDate), 'day')
            ? moment
              .utc(parsedValue.startDate)
              .set({
                hour: moment.utc().hour(),
                minute: moment.utc().minute(),
                second: moment.utc().second(),
                millisecond: moment.utc().millisecond(),
              })
              .toISOString()
            : moment.utc(parsedValue.endDate).isBefore(moment.utc(), 'day')
              ? moment
                .utc()
                .set({
                  hour: moment.utc().hour(),
                  minute: moment.utc().minute(),
                  second: moment.utc().second(),
                  millisecond: moment.utc().millisecond(),
                })
                .toISOString()
              : moment.utc(parsedValue.endDate).toISOString()
          : null,
        utilityId: Boolean(parsedValue?.utilityId)
          ? utilitiesValues.filter((data: any) => data.value === parsedValue?.utilityId)[0].id
          : null,
        contractTypeId: Boolean(parsedValue?.contractTypeId)
          ? contractTypeValues.filter((data: any) => data.value === parsedValue?.contractTypeId)[0]
            .id
          : null,
        unit: Boolean(parsedValue?.unitTypeId) ? parsedValue?.unitTypeId : null,
        unitTypeId: Boolean(parsedValue?.unitTypeId)
          ? unitValues.filter((data: any) => data.value === parsedValue?.unitTypeId)[0].id
          : null,
        rate: Boolean(parsedValue?.rate) ? Number(parsedValue?.rate) : null,
        secondRate: Boolean(parsedValue?.secondRate) ? Number(parsedValue?.secondRate) : null,
        term: Boolean(parsedValue?.term) ? parsedValue?.term : null,
        earlyTerminationFee: Boolean(parsedValue?.earlyTerminationFee)
          ? Number(parsedValue?.earlyTerminationFee)
          : null,
        serviceFee: Boolean(parsedValue?.serviceFee) ? Number(parsedValue?.serviceFee) : null,
        adder: Boolean(parsedValue?.adder) ? Number(parsedValue?.adder) : null,
        deposit: Boolean(parsedValue?.deposit) ? Number(parsedValue?.deposit) : null,
        ecode: Boolean(parsedValue?.ecode) ? parsedValue?.ecode : null,
        ebillingMethod: Boolean(parsedValue?.ebillingMethod) ? parsedValue?.ebillingMethod : null,
        gcontractTypeId: Boolean(parsedValue?.gcontractTypeId)
          ? contractTypeValues.filter((data: any) => data.value === parsedValue?.gcontractTypeId)[0]
            .id
          : null,
        gutilityId: Boolean(parsedValue?.gutilityId)
          ? utilitiesValues.filter((data: any) => data.value === parsedValue?.gutilityId)[0].id
          : null,
        gunit: Boolean(parsedValue?.gunitTypeId) ? parsedValue?.gunitTypeId : null,
        gunitTypeId: Boolean(parsedValue?.gunitTypeId)
          ? unitValues.filter((data: any) => data.value === parsedValue?.gunitTypeId)[0].id
          : null,
        grate: Boolean(parsedValue?.grate) ? Number(parsedValue?.grate) : null,
        gsecondRate: Boolean(parsedValue?.gsecondRate) ? Number(parsedValue?.gsecondRate) : null,
        gterm: Boolean(parsedValue?.gterm) ? parsedValue?.gterm : null,
        gearlyTerminationFee: Boolean(parsedValue?.gearlyTerminationFee)
          ? Number(parsedValue?.gearlyTerminationFee)
          : null,
        gserviceFee: Boolean(parsedValue.gserviceFee) ? Number(parsedValue?.gserviceFee) : null,
        gadder: Boolean(parsedValue?.gadder) ? Number(parsedValue?.gadder) : null,
        gdeposit: Boolean(parsedValue?.gdeposit) ? Number(parsedValue?.gdeposit) : null,
        gcode: Boolean(parsedValue?.gcode) ? parsedValue?.gcode : null,
        gbillingMethod: Boolean(parsedValue?.gbillingMethod) ? parsedValue?.gbillingMethod : null,
        dynamicProductInput: parsedValue?.dynamicProductInput,
      }))

      const uploadProducts = async (products: any) => {
        try {
          await createBulkProduct({
            variables: {
              createProductInput: products,
            },
          })
        } catch (error) {
          console.error('Error uploading products:', error)
          MySwal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error uploading products',
          })
        }
      }

      // Handle batch uploading if payload is large
      if (payload.length > 80) {
        const splitArrays = []
        for (let i = 0; i < payload.length; i += 80) {
          splitArrays.push(payload.slice(i, i + 80))
        }

        for (const item of splitArrays) {
          await uploadProducts(item)
        }
      } else {
        await uploadProducts(payload)
      }

      handleModalClose()
    } catch (error) {
      console.error('Error in handleSubmit:', error)
      MySwal.fire({
        icon: 'error',
        title: 'Error',
        text: 'An error occurred while processing your request',
      })
    }
  }
  return (
    <>
      <CustomButton
        text='Import'
        pathfromImages='uploadIcon.svg'
        className='btn btn-active-light-primary btn-active-icon-white btn-light-primary '
        onClick={() => setShowModal(true)}
      />
      <SharedModal
        handleClose={handleModalClose}
        className='mw-750px'
        handleSubmit={handleSubmit}
        show={showModal}
        headerName='Import Products'
        disableSubmit={Boolean(errorMsg) || parsedValues?.length === 0}
        headerContent={
          <DownloadTemplate
            href={
              isProductListDynamic
                ? process.env.REACT_APP_DYNAMIC_PRODUCT_TEMPLATE_DOWNLOAD
                : process.env.REACT_APP_PRODUCT_TEMPLATE_DOWNLOAD
            }
            text='Download Template'
          />
        }
        submitText='Import'
      >
        <div className='p-4'>
          {/* <UploadCSV onUploadAccepted={(data) => console.log('data----', data)} /> */}
          <DragDrop
            setFile={setFile}
            file={file}
            label={'Click here to upload or drag and drop'}
            fileTypes={['csv']}
            customDragDropSection={
              <div className='d-flex h-100 justify-content-center align-items-center border-dashed border-1 border-gray-400'>
                <p className='text-danger'>{errorMsg}</p>
                {!Boolean(errorMsg) && !Boolean(file) && (
                  <p className=''>Click here to select file or drag and drop</p>
                )}
                {Boolean(file) && (
                  <div className='d-flex flex-column align-items-center'>
                    <img
                      width={35}
                      height={35}
                      className='m-auto mb-2'
                      src={succesIcon}
                      alt='success'
                    />
                    <p> File uploaded succesfully</p>
                  </div>
                )}
              </div>
            }
          />
        </div>
      </SharedModal>
    </>
  )
}
export default UploadProducts
